import { Component, h } from "@lukekaalim/act";
import { html } from "@lukekaalim/act-web";
import { Header } from "../Header";
import { Hero } from "./Hero";
import { AnimatedFeatureList } from "./AnimatedFeatureList";

import classes from './index.module.css';
import { Footer } from "../Footer";
import { AuthState } from "../../hooks";

export type SesameHomeProps = {
  auth: AuthState
};

export const SesameHome: Component<SesameHomeProps> = ({ auth }) => {
  return h(html.main, { className: classes.home }, [
    h(Header, { auth, account: auth.account }),
    h(Hero, { auth }),
    h(AnimatedFeatureList),
    h(Footer, { account: auth.account }),
  ])
};
